import * as React from "react";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import customerReview from "../../../assets/img/features/customer-review.png";

export default function CustomerReview() {
  return (
    <Box
      sx={{
        width: "100%",
        padding:  {xs:"2rem 0", md:"10rem 0"},
        background: "linear-gradient(180deg, rgba(244, 249, 255, 0) 0%, #F4F9FF 100%)",
      }}
    >
      <Box
        sx={{
          height: "inherit",
          width: "inherit",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-evenly",
          alignItems: "center"
        }}
      >
        <Box>
          <img src={customerReview} alt="loading..." width={350} />
        </Box>
        <Box sx={{ width: { sx: "90vw", md: "40vw", padding: "2rem" } }}>
          <Typography variant="h3" gutterBottom fontWeight={800}>
          Get Feedback from your customers

          </Typography>
          <Typography variant="h5" gutterBottom fontWeight={300} fontSize="1.2rem">
          Listen to your customers, learn what your customers are saying about your brand and drive improvements that your customers LOVE !
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
